import utils from '@eitje/utils'

export const getCoordinates = (spacing, type) => {
	if (!spacing) return

	const coordinates = _.isString(spacing) ? spacing.split(' ') : utils.alwaysArray(spacing)
	const [top, right = top, bottom = top, left = right] = coordinates
	const properties = {top, right, bottom, left}

	const result = {}
	Object.keys(properties).forEach(key => {
		const value = properties[key]
		if (value !== '-') {
			const rawName = key // e.g. top, bottom
			const prefixedName = `${type}${utils.capitalize(rawName)}` // e.g. MarginTop or PaddingTop
			const stylingName = type ? prefixedName : rawName

			result[stylingName] = value
		}
	})

	return result
}

export const getMargin = margin => getCoordinates(margin, 'margin')
export const getPadding = padding => getCoordinates(padding, 'padding')
